module.exports = __webpack_public_path__ + "static/media/masjid_ummu_kulthum_hilal6.e1a7a19a.webp";